import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ClientenFilter} from './clienten-filter';
import {Zone} from '../../../zone/zone';
import {Diensten} from '../../../dienst/diensten';

@Component({
    selector: 'zah-clienten-filter',
    templateUrl: './clienten-filter.component.html',
    styleUrls: ['./clienten-filter.component.scss'],
    standalone: false
})
export class ClientenFilterComponent {

  @Input()
  enableZonesAndDienstenFilter: boolean = true;
  @Input()
  zones: Array<Zone>;
  @Input()
  diensten: Diensten;
  @Output()
  newSearch: EventEmitter<ClientenFilter> = new EventEmitter<ClientenFilter>();

  clientenFilter: ClientenFilter = new ClientenFilter();

  onResetSearch(): void {
    this.clientenFilter.reset();
    this.newSearch.emit(this.clientenFilter);
  }

  onSearch(): void {
    if (this.clientenFilter.isAchternaamSearchValid()) {
      this.newSearch.emit(this.clientenFilter);
    }
  }
}
